import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, ref } from 'vue';
import FilterIcon from '@/js/components/icons/FilterIcon.vue';
import EventsCalendarFilterDrawer from './EventsCalendarFilterDrawer.vue';
import {
  getEventsCalendarScope,
  hasActiveEventsCalendarDrawerFilters,
} from './sync-filters';


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const filterOpen = ref(false);
const filtersRevision = ref(0);

const isFilterApplied = computed(() => {
  filtersRevision.value;

  return hasActiveEventsCalendarDrawerFilters(getEventsCalendarScope());
});

function handleApplied(): void {
  filtersRevision.value += 1;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", {
      type: "button",
      class: "events-calendar-filter__trigger btn btn-secondary btn-medium",
      "aria-label": "Фильтр",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (filterOpen.value = true))
    }, [
      _createVNode(FilterIcon, { filled: isFilterApplied.value }, null, 8, ["filled"])
    ]),
    _createVNode(EventsCalendarFilterDrawer, {
      open: filterOpen.value,
      "onUpdate:open": _cache[1] || (_cache[1] = ($event: any) => ((filterOpen).value = $event)),
      onApplied: handleApplied
    }, null, 8, ["open"])
  ], 64))
}
}

})